/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstantConversationUsageResponse
 */
export interface InstantConversationUsageResponse {
    /**
     * 
     * @type {number}
     * @memberof InstantConversationUsageResponse
     */
    usage: number;
    /**
     * 
     * @type {number}
     * @memberof InstantConversationUsageResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the InstantConversationUsageResponse interface.
 */
export function instanceOfInstantConversationUsageResponse(value: object): value is InstantConversationUsageResponse {
    if (!('usage' in value) || value['usage'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function InstantConversationUsageResponseFromJSON(json: any): InstantConversationUsageResponse {
    return InstantConversationUsageResponseFromJSONTyped(json, false);
}

export function InstantConversationUsageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstantConversationUsageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'usage': json['usage'],
        'limit': json['limit'],
    };
}

export function InstantConversationUsageResponseToJSON(value?: InstantConversationUsageResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'usage': value['usage'],
        'limit': value['limit'],
    };
}

